export enum PatientFormGender {
  Male = "male",
  Female = "female",
}
